<script>
    import { onMount } from "svelte";

    export let totalReadTime = "5 min read"; // e.g., "5 min read"

    let scrollProgress = 0;
    let timeRemaining = totalReadTime;
    let isVisible = false;

    // Parse the total read time to get minutes
    const totalMinutes = parseInt(totalReadTime.match(/\d+/)?.[0] || 5);

    function updateProgress() {
        const intro = document.querySelector("#intro");
        const articleContent = document.querySelector(".blog-post__content");
        const articleFooter = document.querySelector(".blog-post__footer");

        if (!intro || !articleContent || !articleFooter) return;

        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;

        // Get the exact boundaries of just the article content
        const contentStart = articleContent.offsetTop;
        const contentEnd =
            articleContent.offsetTop + articleContent.offsetHeight;
        const contentHeight = articleContent.offsetHeight;

        // Get intro section end
        const introEnd = intro.offsetTop + intro.offsetHeight;

        // Show 200px before scrolling past intro, hide after scrolling past content
        const scrolledPastIntro = scrollTop > introEnd - 200;
        const scrolledPastContent = scrollTop > contentEnd;

        // Show only when past intro and still in article content area
        isVisible = scrolledPastIntro && !scrolledPastContent;

        // Calculate progress within the article content only
        // Progress based on how much of the content has scrolled past the top of viewport
        const scrollWithinContent = Math.max(0, scrollTop - contentStart);
        const progress = Math.min(scrollWithinContent / contentHeight, 1);

        scrollProgress = progress * 100;

        // Calculate time remaining based on scroll progress
        const minutesRemaining = Math.ceil(totalMinutes * (1 - progress));

        if (minutesRemaining <= 0 || scrolledPastContent) {
            timeRemaining = "Done!";
        } else if (minutesRemaining === 1) {
            timeRemaining = "1 min left";
        } else {
            timeRemaining = `${minutesRemaining} min left`;
        }
    }

    onMount(() => {
        // Small delay to ensure DOM is fully rendered
        setTimeout(updateProgress, 100);

        window.addEventListener("scroll", updateProgress, { passive: true });
        window.addEventListener("resize", updateProgress, { passive: true });

        return () => {
            window.removeEventListener("scroll", updateProgress);
            window.removeEventListener("resize", updateProgress);
        };
    });
</script>

<div class="reading-progress" class:visible={isVisible}>
    <div class="reading-progress__text">
        {timeRemaining}
    </div>
    <div class="reading-progress__bar">
        <div
            class="reading-progress__fill"
            style="height: {scrollProgress}%"
        ></div>
    </div>
    <div class="reading-progress__percent">
        {Math.round(scrollProgress)}%
    </div>
</div>

<style>
    .reading-progress {
        position: fixed;
        left: calc(50% - 400px - 3.5rem);
        top: 50%;
        transform: translateY(-50%);
        z-index: 50;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;
        opacity: 0;
        transition: opacity 0.3s ease;
        pointer-events: none;
    }

    .reading-progress.visible {
        opacity: 1;
    }

    .reading-progress__text {
        font-size: 0.75rem;
        font-weight: 700;
        color: light-dark(#333, var(--color-yellow, var(--color-yellow-hex)));
        white-space: nowrap;
        writing-mode: vertical-rl;
        text-orientation: mixed;
        letter-spacing: 0.5px;
        text-transform: uppercase;
    }

    .reading-progress__bar {
        width: 3px;
        height: 200px;
        background: rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        overflow: hidden;
        position: relative;
    }

    .reading-progress__fill {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: var(--color-blue, var(--color-blue-hex, #00b0ff));
        transition: height 0.2s ease;
        border-radius: 2px;
    }

    .reading-progress__percent {
        font-size: 0.7rem;
        font-weight: 600;
        color: light-dark(#666, var(--color-yellow, var(--color-yellow-hex)));
    }

    @media (max-width: 1000px) {
        .reading-progress {
            left: 1rem;
        }
    }

    @media (max-width: 768px) {
        .reading-progress {
            display: none;
        }
    }
</style>
